<template>
  <v-row no-gutters class="usp-row mb-12">
    <v-col cols="12" sm="6" md="3" class="my-4">
      <v-row class="usp-box">
        <v-col cols="12" class="usp-container usp">
          <v-col cols="12" class="usp-img-box">
            <v-img :src="require(`@/assets/${whitelabel.images.homeUsp1}`)" alt="Convenient online will creation" title="Convenient online will creation" class="mx-auto usp-images" />
          </v-col>
          <h3 class="usp-heading">Save time &amp; money</h3>
          <p class="usp-text">Create your will any time, anywhere, without having to meet with a lawyer</p>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="my-4">
      <v-row class="usp-box">
        <v-col cols="12" class="usp-container">
          <v-col cols="12" class="usp-img-box">
            <v-img :src="require(`@/assets/${whitelabel.images.homeUsp2}`)" alt="Robust security" title="Robust security" class="mx-auto usp-images" />
          </v-col>
          <h3 class="usp-heading">Data Privacy</h3>
          <p class="usp-text">We keep your personal information safe &amp; secure, using bank grade security</p>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="my-4">
      <v-row class="usp-box">
        <v-col cols="12" class="usp-container">
          <v-col cols="12" class="usp-img-box">
            <v-img :src="require(`@/assets/${whitelabel.images.homeUsp3}`)" alt="Support to create will" title="Support to create will" class="mx-auto usp-images" />
          </v-col>
          <h3 class="usp-heading">High touch support</h3>
          <p class="usp-text">Reliable service to help guide you and answer any questions you have at any time</p>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="my-4">
      <v-row class="usp-box">
        <v-col cols="12" class="usp-container">
          <v-col cols="12" class="usp-img-box">
            <v-img :src="require(`@/assets/${whitelabel.images.homeUsp4}`)" alt="Easily update your will" title="Easily update your will" class="mx-auto usp-images" />
          </v-col>
          <h3 class="usp-heading">Easy online updates</h3>
          <p class="usp-text">Once subscribed, simply login &amp; update your will, whenever you like</p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
   export default {
    name: 'HomePageUsps'
  }
</script>

<style scoped lang="css">

.usp-row {
  width: 80%;
  margin: auto;
}

.usp-box {
  /* border: 2px solid rgba(58,222,180, 0.3); */
  border-radius: 7px;
  width: 85%;
  height: 335px;
  margin: auto;
  padding: 15px;
  padding: 0;
}

.usp-img-box {
  /* background-color: rgba(58,222,180, 0.3); */
}

.usp .usp-img-box {
  padding-top: 20px;
}

.usp-container {
  margin-bottom: 21px;
  padding: 0;
}

.usp-images {
  max-height: 150px;
  max-width: 150px;
  margin-bottom: 15px;
}

.usp-heading {
  font-size: 16px;
  font-weight: bold;
  padding-left: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.usp-text {
  font-size: 15px;
  padding-left: 8px;
  padding-right: 8px;
}

</style>